module.exports = __webpack_public_path__ + "static/media/polydimethylsiloxane.9aab51b8.png";